import LineItem from "./Lineitem";

class Project {
  constructor(data) {
    this._data = data;
  }

  getId() {
    if (!this._data) {
      return "123456";
    }

    return this._data.extProjectId;
  }

  getTitle() {
    if (!this._data) {
      return "Some Project";
    }
    return this._data.title;
  }

  getStudyType() {
    if (!this._data) {
      return "Some Study Type";
    }

    // todo get type
    return this._data.title;
  }

  getDeviceTypes() {
    if (!this._data) {
      return [];
    }

    return this._data.devices || [];
  }

  getCategories() {
    if (!this._data) {
      return {};
    }

    return this._data.categories || {};
  }

  getLineItem() {
    if (!this._data) {
      return [];
    }

    return [new LineItem(this._data.lineItem)];
  }
}

export default Project;
